import AutoForm from '@/components/AutoForm'
export default {
  components: {
    AutoForm
  },
  data(){
    let validateComname = (rule, value, callback) => {
      var self = this;
      self.$http.post(self.url.VerifyCustomCompanyName, {
        Data: {
          CompanyName:value,
          CompanyId:self.form.Id
        }
      }).then(result => {
        if(!result){
          callback(new Error('企业名称已存在，换一个吧~'));
        }else{
          callback();
        }
      }, () => {

      });
    };
    // 银行卡号
    let validateBankcard2 = (rule, value, callback) => {
      if(!this.form.Account) {
        callback();
        // }
        // else if (!this.bankIsOk) {
        //   callback(new Error('您输入的银行卡号暂不支持！'));
      } else {
        validateBankcard(rule, value, callback);
      }
    };
    // 营业执照
    let validateBusinessLicense = (rule, value, callback) => {
      var reg = /(^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$)|(^\d{15}$)/;
      if(!this.form.BusinessLicense) {
        callback();
      }
      else if (!reg.test(value)) {
        callback(new Error('您输入正确的营业执照！'));
      } else {
        callback();
      }
    };

    // 法人
    let validateJuridicalPerson = (rule, value, callback) => {
      if(!this.form.JuridicalPerson) {
        callback();
      }
      else if (value.length > 5) {
        callback(new Error('长度不能超过 5 个字符'));
      } else {
        callback();
      }
    };

    // 税号
    let validateDutyParagraph = (rule, value, callback) => {
      var reg = /^[A-Z0-9]{15}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/;
      if(!this.form.DutyParagraph) {
        callback();
      }
      else if (!reg.test(value)) {
        callback(new Error('您输入正确的税号！'));
      } else {
        callback();
      }
    };

    // 电话
    let validatePhone2 = (rule, value, callback) => {
      var reg = /^((0\d{2,3}-\d{7,8})|(1[3567849]\d{9}))$/;
      if(!this.form.Phone) {
        callback();
      }
      else if (!reg.test(value)) {
        callback(new Error('您输入号码格式不正确或者位数不正确！'));
      } else {
        callback();
      }
      /*else {
        validatePhone(rule, value, callback);
      }*/
    };
    // 传真
    let validateFax= (rule, value, callback) => {
      if(!this.form.Fax) {
        callback();
      }
      else if (value.length > 20) {
        callback(new Error('长度不能超过 20 个字符'));
      } else {
        callback();
      }
    };
    // 邮编
    let validateZipCode= (rule, value, callback) => {
      if(!this.form.ZipCode) {
        callback();
      }
      else if (value.length > 50) {
        callback(new Error('长度不能超过 50 个字符'));
      } else {
        callback();
      }
    };
    // 证件号码格式验证
    let validateConfirmIdCard = (rule, value, callback) => {
      if(!this.form.ContactCardId) {
        callback();
      }
      switch (this.form.ContactCardType) {
        case 0: //
          validateIdCard(rule, value, callback);
          break;
        case 1:
          validatePassport(rule, value, callback);
          break;
        case 2:
          validateMilitaryCard(rule, value, callback);
          break;
        case 9:
          validateHMPassCard(rule, value, callback);
          break;
      }
    };
    // 联系人邮箱验证
    let validateContactsEmail = (rule, value, callback) => {
      var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      if(!this.form.ContactsEmail) {
        callback();
      }
      else if (!reg.test(value)) {
        callback(new Error('您输入邮箱格式不正确！'));
      } else {
        callback();
      }
    };
    return{

      form: {
        ContactsName:'',
        ContactCardNumber:'',
        ContactsEmail:'',
        AccountHolderName:'',
        Account:'', Bank:'', Province:'',City:'',AccountBank: null,
        ObversePicLst:[],ReversePicLst:[],State:null,
        BankProvince:null,BankCity:null,AreaId:null,DefaultSalesman:'',AuditMsg:''
      },

      rules: {
        ContactsName :[
          { required: true, message: '请输入您的姓名', trigger: 'blur' },
          {  max: 10, message: '姓名长度不能超过 10 个字符', trigger: 'blur' }
        ],
        ContactCardNumber :[
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          {
            validator: validateIdCard,
            trigger: 'blur'
          }
        ],
        ObversePicLst:[
          {
            required: true,
            message: '请上传身份证正面照片',
            trigger: 'blur'
          },
        ],
        Account: [
          {
            required: true,
            message: '请输入银行账号',
            trigger: 'blur'
          },
          {
            validator: validateBankcard2,
            trigger: 'blur'
          }
        ],
        AccountHolderName :[
          { required: true, message: '请输入开户人姓名', trigger: 'blur' },
          {  max: 10, message: '姓名长度不能超过 10 个字符', trigger: 'blur' }
        ],
        Bank: [{ required: true, message: '请选择开户行', trigger: 'change' }],
        Province: [{ required: true, message: '请选择所属省份', trigger: 'change' }],
        City: [{ required: true, message: '请选择所属城市', trigger: 'change' }],
        AreaId: [{ required: true, message: '请选择所属区县', trigger: 'change' }],
        BankProvince: [{ required: true, message: '请选择开户省份', trigger: 'change' }],
        BankCity: [{ required: true, message: '请选择开户城市', trigger: 'change' }],
        DefaultSalesman: [{ required: true, message: '请选择业务员', trigger: 'change' }],
        // AccountBank: [{ required: true, message: '请选择开户银行支行', trigger: 'change' }],
        AccountBank: [{required: true, message: '请填写开户银行支行', trigger: 'blur'}],//原先为下拉  改为手填 2021/11/19

        ReversePicLst:[
          {
            required: true,
            message: '请上传身份证反面照片',
            trigger: 'blur'
          },
        ]
      },

      formTemplatenew:[
        { col:24, type: 'tips', tips:'基本信息' },
        { col:12, label:'姓名', prop:'ContactsName',change: () => { this.changeName(); }},
        { col:12, label:'身份证号', prop:'ContactCardNumber' },
        { col: 12, label: '所属省份', prop: 'Province', type: 'select', options: [], change: () => { this.loadCity(); }, filterable: true, default: '' }, // 24
        { col: 12, label: '所属地级市', prop: 'City', type: 'select', options: [],filterable: true, default: '' }, // 25
        // { col:24, type: 'tips', tips:'银行卡信息' },
        // { col:24, label: '银行账号', prop: 'Account', default: '' },
        // { col:24, label: '开户银行', prop: 'Bank', type: 'select', options: [], filterable: true, change: () => { this.loadBankBranch(); } },
        // { col:24, label: '开户人', prop: 'AccountHolderName',cannotEidt:true},
        // { col:12, label: '开户省份', prop: 'BankProvince', type: 'select', options: [], change: () => { this.loadBankCity(); }, filterable: true },
        // { col:12, label: '开户地级市', prop: 'BankCity', type: 'select', options: [], filterable: true, change: () => { this.loadBankBranch(); } },
        // //{ col:24, label: '开户银行支行', prop: 'AccountBank', type: 'select', options: [], filterable: true, default: '' },
        // {col: 24, label: '开户银行支行', prop: 'AccountBank', clearable:true}, //原先为下拉  后改为手填

        { col:24, type: 'tips', tips:'业务员' },
        { col:24, label: '业务员', prop: 'DefaultSalesman', type: 'select', options: [], filterable: true, default: '' },
        { col:24, type: 'tips', tips:'附件' },
        { col:12, label:'身份证正面', prop:'ObversePicLst', type:'picture-list', default:[], formIdProp: 'Id', pictureType: 'CustomRealNameAuth', limit: 1 },
        { col:12, label:'身份证反面', prop:'ReversePicLst', type:'picture-list', default:[], formIdProp: 'Id', pictureType: 'CustomRealNameAuth', limit: 1 },
      ],
      url: {
        province: SZH.assets.api + "/Market/GetSelectProvince",
        city: SZH.assets.api + "/Market/GetSelectCity",
        GetSelectArea: SZH.assets.api + "/Market/GetSelectArea",
        bank: SZH.assets.api + "/Market/GetSelectBaseBank",
        bankBranch: SZH.assets.api + "/Market/GetSelectBankInfo",
        bankSearch: SZH.assets.api + "/Market/GetBankMapping",

        get: SZH.assets.api + '/Custom/GetCustomAuthInfo',
        get2: SZH.assets.api + '/Custom/GetCustomRealNameInfo',
        save: SZH.assets.api + '/Custom/UploadCustomAuthInfo',
        getCode: SZH.assets.api + '/Authen/GetCustomSAPNo',
        saveCommon:SZH.assets.api + '/Custom/SaveCustomRealName',
        VerifyCustomCompanyName:SZH.assets.api + '/Authen/VerifyCustomCompanyName',
        CheckQualificationIsDue: SZH.assets.api + '/Custom/CheckQualificationIsDue',
        GetSelectSalesUser: SZH.assets.api + '//Custom/GetSelectSalesUserTS',
      },

      isEdit:true,
      uploading:false,
      loading:false,
      boxLoading:false,
      bigForm:{},
      rowId:'',
      BindQualifications:[]//资质列表
    }
  },
  methods:{
    changeName(){
      this.form.AccountHolderName = this.form.ContactsName;
    },
    ToSubmit(){
      let self = this;
      self.$confirm('为了您能够正常充值和退款，请再次检查持卡人与身份证完全一致，如因信息不一致造成的钱款无法退回，本公司概不负责,确认保存吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        self.$refs['form'].validate((valid) => {
          if (valid) {
            self.$http.post(self.url.save, self.form).then(result => {
              if(result.state == true){
                self.$message.success('提交成功');
                self.$router.push({
                  path: '/My/companyFinished'
                })
              }else{
                self.$message.error(result.message);
              }
            }, () => {
            });
          } else {
            return false;
          }
        });
      }).catch(() => {
        self.$message({
          type: 'info',
          message: '已取消保存'
        });
      });
    },
    formatDate(datetime) {
      return new Date(datetime).format('yyyy-MM-dd');
    },

    selectChange(v){
      this.form.ContactCardId = null
    },

    beforeSave() {
      this.uploading = true;
    },
    afterSaved() {
      this.uploading = false;
    },
    onSaved() {
      this.$message.success("保存成功");
      this.$router.push({
        path: '/My/Info'
      })
    },

    loadProvince() {
      var self = this;
      self.$http.post(self.url.province, {}).then(result => {
        for (let i in self.formTemplatenew){
          if(self.formTemplatenew[i].prop == 'Province' || self.formTemplatenew[i].prop == 'BankProvince'){
            if (result.state == true && result.data != null){
              self.formTemplatenew[i].options = result.data;
            }else{
              self.formTemplatenew[i].options = [];
            }
          }
        }
      }, () => {
      });
    },
    //

    goBack() {
      this.$router.go(-1)
    },
    loadCity(v,flag) {
      var self = this;
      if(!flag){
        self.form.City = null;
        self.form.AreaId = null;
      }
      self.$http.post(self.url.city, { KeyValue: self.form.Province }).then(result => {
        for (let i in self.formTemplatenew){
          if(self.formTemplatenew[i].prop == 'City'){
            if (result.state == true && result.data != null){
              self.formTemplatenew[i].options = result.data;
            }else{
              self.formTemplatenew[i].options = [];
            }
          }
        }
      }, () => {
      });
    },
    loadBankCity(v,flag) {

      var self = this;
      if(!flag){
        self.form.BankCity = null;
      }
      self.$http.post(self.url.city, { KeyValue: self.form.BankProvince }).then(result => {
        for (let i in self.formTemplatenew){
          if(self.formTemplatenew[i].prop == 'BankCity'){
            if (result.state == 1 && result.data != null){
              self.formTemplatenew[i].options = result.data;
            }else{
              self.formTemplatenew[i].options = [];
            }
          }
        }
      }, () => {
      });
    },

    loadBanks() {
      var self = this;
      self.$http.post(self.url.bank, { KeyValue: self.form.BankProvince }).then(result => {
        for(var i in self.formTemplatenew){
          if(self.formTemplatenew[i].prop == 'Bank'){
            if (result.state == true && result.data != null){
              self.formTemplatenew[i].options = result.data;
            }else{
              self.formTemplatenew[i].options = [];
            }
          }
        }
      }, () => {
      });
    },
    loadBankBranch() {
      var self = this;
      if (self.form.BankCity != '' && self.form.BankCity != null && self.form.Bank != '' && self.form.Bank != null) {
        // self.form.AccountBank = null;
        self.$http.post(self.url.bankBranch, {
          KeyValue: {
            BankId: self.form.Bank,
            CityId: self.form.BankCity,
          }
        }).then(result => {
          // for(var i in self.formTemplatenew){
          //   if(self.formTemplatenew[i].prop == 'AccountBank'){
          //     if (result.state == true && result.data != null){
          //       self.formTemplatenew[i].options = result.data;
          //     }else{
          //       self.formTemplatenew[i].options = [];
          //     }
          //   }
          // }
        }, () => {
        });
      }
    },
    GetCompanyInfoNewFun() {
      var self = this;
      self.$http.post(self.url.get, {
        KeyValue:{
          ApiType: 1
        }
      }).then(result => {
        if (result.state == true && result.data != null) {
          if(result.data.State == null){
            return
          }
          for(let i in self.form){
            for(let k in result.data){
              if(i == k){
                self.form[i] = result.data[k];
              }
            }
          }
          if(result.data.Id){
            self.loadCity('',true);
            self.loadBankCity('',true);
            self.loadBankBranch();
          }
        } else {
        }
      }, () => {
      });
    },
    GetSelectSalesUserFun() {
      var self = this;
      self.$http.post(self.url.GetSelectSalesUser, {}).then(result => {
        for (var i in self.formTemplatenew) {
          if (self.formTemplatenew[i].prop == 'DefaultSalesman') {
            if (result.state == true && result.data != null) {
              self.formTemplatenew[i].options = result.data;
            } else {
              self.formTemplatenew[i].options = [];
            }
          }
        }
      }, () => {
      });
    },
  },
  created(){

  },
  mounted() {
    this.loadBanks();
    this.loadProvince();
    this.GetSelectSalesUserFun();
    this.GetCompanyInfoNewFun();
  },
  watch: {

  }
}



// WEBPACK FOOTER //
// ./src/views/Me/EgQualifications/EgQualifications.js